import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { DialogHost } from './dialogs';
import { applyTheme, savedTheme } from './theme';

if (/Mac/i.test(navigator.platform)) document.documentElement.classList.add('is-mac');
applyTheme(savedTheme());

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <DialogHost />
  </React.StrictMode>,
);
